export default __webpack_public_path__ + "static/assets/acc60fb1f6a316b1c6d9f18c4adec2c7.png";